import { useCallback } from 'react';
import { useComscoreTracking } from '@/hook/useComscoreTracking';

export function useGlobalContentClick() {
  const { trackContentClick } = useComscoreTracking();

  const handleGlobalContentClick = useCallback(
    (e) => {
      // data-content-id를 가진 부모 엘리먼트 탐색
      const targetCard = e.target.closest('[data-content-id]');

      if (targetCard) {
        const id = targetCard.getAttribute('data-content-id');
        const type = targetCard.getAttribute('data-content-type') || 'COMMON';

        if (id) {
          // 결과 예시: "NEWS_10482", "TV_5821", "RADIO_302"
          const formattedCode = `${type}_${id}`;
          trackContentClick(formattedCode); // c10 전송
        }
      }
    },
    [trackContentClick],
  );

  return handleGlobalContentClick;
}
